import React, { Component } from 'react';
import { Button, Form, Input, message, Modal } from 'antd';
import { Message } from 'semantic-ui-react';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';

const FormItem = Form.Item;
const TextArea = Input.TextArea;

class CptNoteModalDialog extends Component {
  componentDidUpdate() {
    const {
      addOrEditCptNoteActionStatus,
      loadCptNoteActionStatus,
    } = this.props;

    if (loadCptNoteActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadCptNoteActionStatus();
    }

    if (loadCptNoteActionStatus === ACTION_STATUS.ERROR) {
      message.error('Load CPT Note failed');
      this.props.initLoadCptNoteActionStatus();
    }

    if (addOrEditCptNoteActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Save CPT Note succeeded');
      this.props.initAddOrEditCptNoteActionStatus();
      this.props.resetCptNoteModal();
    }

    if (addOrEditCptNoteActionStatus === ACTION_STATUS.ERROR) {
      this.props.initAddOrEditCptNoteActionStatus();
    }
  }

  onInputChange = ({ name, value }) => {
    this.props.cptNoteChangeInput({ name, value });
  };

  submitCptNote = () => {
    const { fields } = this.props.cptNoteModal;
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.addOrEditCptNote({
          id: fields.id,
          note: fields.note,
          mode: fields.id ? 'EDIT' : 'ADD',
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      cptNoteModal,
      loadCptNoteActionStatus,
      addOrEditCptNoteActionStatus,
    } = this.props;
    const { isOpened, respErrMsg, fields } = cptNoteModal;
    const isSubmitLoading = addOrEditCptNoteActionStatus === ACTION_STATUS.LOGINING;
    const isLoading = loadCptNoteActionStatus === ACTION_STATUS.LOGINING;

    return (
      <Modal
        title="CPT Note"
        centered
        width={720}
        visible={isOpened}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.props.resetCptNoteModal}
        footer={[
          <Button key="close" onClick={this.props.resetCptNoteModal}>
            Close
          </Button>,
          <Button key="submit" type="primary" loading={isSubmitLoading} onClick={this.submitCptNote}>
            Submit
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <FormItem label="Note">
            {getFieldDecorator('note', {
              initialValue: fields.note,
            })(
              <TextArea
                rows={8}
                disabled={isLoading}
                onChange={e => this.onInputChange({ name: 'note', value: e.target.value })}
              />
            )}
          </FormItem>
        </Form>
        {!!respErrMsg && (
          <Message negative>
            <Message.Header>Response Error Message</Message.Header>
            <p>{respErrMsg}</p>
          </Message>
        )}
      </Modal>
    );
  }
}

const CptNoteModalDialogForm = Form.create({ name: 'CptNoteModalDialog' })(CptNoteModalDialog);

export default CptNoteModalDialogForm;
